import { useState } from 'react';
import { useLocation } from 'wouter';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, Sparkles, TrendingUp, ChevronRight } from 'lucide-react';

const slides = [
  {
    icon: BookOpen,
    title: '上传书籍',
    description: '支持PDF格式,轻松导入您的电子书籍',
    color: '#22a9d9'
  },
  {
    icon: Sparkles,
    title: 'AI生成卡片',
    description: '智能提取知识点,自动生成结构化学习卡片',
    color: '#6c5ce7'
  },
  {
    icon: TrendingUp,
    title: '高效学习',
    description: '滑动刷卡片,随时随地巩固知识',
    color: '#22a9d9'
  }
];

export default function Welcome() {
  const [, setLocation] = useLocation();
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      // 标记已看过引导
      localStorage.setItem('hasSeenWelcome', 'true');
      setLocation('/login');
    }
  };

  const handleSkip = () => {
    localStorage.setItem('hasSeenWelcome', 'true');
    setLocation('/login');
  };

  return (
    <div className="min-h-screen bg-[#1a2e3e] flex flex-col items-center justify-center p-6 relative overflow-hidden">
      {/* 背景装饰 */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#22a9d9] rounded-full blur-[100px]" />
        <div className="absolute bottom-20 right-10 w-64 h-64 bg-[#6c5ce7] rounded-full blur-[100px]" />
      </div>

      {/* 跳过按钮 */}
      <button
        onClick={handleSkip}
        className="absolute top-8 right-8 text-white/60 hover:text-white transition-colors z-10"
      >
        跳过
      </button>

      {/* 内容区域 */}
      <div className="relative z-10 w-full max-w-md">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentSlide}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.3 }}
            className="flex flex-col items-center text-center"
          >
            {/* 图标 */}
            <div
              className="w-32 h-32 rounded-full flex items-center justify-center mb-12"
              style={{
                background: `radial-gradient(circle, ${slides[currentSlide].color}40 0%, transparent 70%)`,
                boxShadow: `0 0 60px ${slides[currentSlide].color}40`
              }}
            >
              {(() => {
                const Icon = slides[currentSlide].icon;
                return <Icon className="w-16 h-16 text-white" />;
              })()}
            </div>

            {/* 标题 */}
            <h1 className="text-4xl font-bold text-white mb-6">
              {slides[currentSlide].title}
            </h1>

            {/* 描述 */}
            <p className="text-xl text-white/70 mb-16 px-4">
              {slides[currentSlide].description}
            </p>
          </motion.div>
        </AnimatePresence>

        {/* 指示器 */}
        <div className="flex justify-center gap-2 mb-12">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`h-2 rounded-full transition-all duration-300 ${
                index === currentSlide
                  ? 'w-8 bg-[#22a9d9]'
                  : 'w-2 bg-white/20'
              }`}
            />
          ))}
        </div>

        {/* 下一步按钮 */}
        <button
          onClick={handleNext}
          className="w-full h-14 rounded-2xl bg-gradient-to-r from-[#22a9d9] to-[#6c5ce7] text-white font-medium text-lg flex items-center justify-center gap-2 hover:shadow-glow transition-shadow"
        >
          {currentSlide < slides.length - 1 ? '下一步' : '开始使用'}
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
